import * as actions from './actions';
import * as getters from './getters';
import AppointmentRecordsState from './state';

export { actions, getters };
export default AppointmentRecordsState;
